import request from "@/utils/request"

export function listOrder(data) {
  return request({
    url: "/orderManage/plat",
    method: "post",
    data: data,
  })
}
export function findCoupon(data) {
  return request({
    url: "/server/order/findCoupon",
    method: "post",
    data: data,
  })
}
export function editCoupon(data) {
    return request({
      url: "/server/order/editCoupon",
      method: "post",
      data: data,
    })
  }
  